import styled, { css } from 'styled-components'

import { ReactComponent as BackFile } from '../../assets/icons/backIcon.svg'

export const BackIcon = styled(BackFile)``

export const BackButton = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    cursor: pointer;

    .back-text {
      margin-left: ${theme.spacing.inline.small};
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 27px;
      letter-spacing: 0em;
      text-align: left;
    }
  `}
`
